export var isoToDisplay = function (value) { return value.replace(/-/g, '/'); };
export var displayToIso = function (value) { return value.replace(/\//g, '-'); };
export var daysInMonth = function (date) { return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate(); };
// we cannot use new Date(string) constructor, because it produces GMT time that may have different date than the local
export var parseDate = function (value) {
    var _a = value.split('-'), year = _a[0], month = _a[1], day = _a[2];
    return new Date(Number(year), (Number(month) || 1) - 1, Number(day) || 1);
};
//# sourceMappingURL=date.js.map